import React, { useState, Component } from 'react';
import { navigate } from '@reach/router';
import { Link } from 'react-scroll';
import { Link as RouterLink } from '@reach/router';
import { useSelector } from 'react-redux';
import { FaBars } from '../../svg/icons';
import '../css/navbar.scss';
import ButtonGame from '../elements/buttonGame';
import logo from '../../assets/images/logo1-preview.png';
import Modal from 'react-modal';
import Terms from '../elements/terms';
import BtnVentas from '../BtnVentas/BtnVentas';
import BtnVentasmb from '../BtnVentas/BtnVentasmb';

function Navbar() {
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '60%',
      zIndex: '100',
      background: '#121035',
      color: '#FFF',
      borderRadius: '10px',
      position: 'relative',
    },
    overlay: {
      display: 'grid',
      justifyContent: 'center',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0, .8)',
      zIndex: '100',
      overflowY: 'auto',
      padding: '20px 0',
    },
  };

  const [showMenu, setShowMenu] = useState(false);
  const { accessToken } = useSelector(({ login }) => login);

  const [modal, setModal] = useState(false);

  const handleOpen = () => setModal(!modal);
  const handleClose = () => setModal(false);

  const handlerLinkTo = (link) => {
    setShowMenu(false);
  };

  return (
    <>
      <div className="navbar grid grid-cols-3  mx-12 ">
        <div className="left w-auto ">
          <Link to="/" onClick={() => handlerLinkTo('/')}>
            <img
              className="nav-logo"
              style={{ height: '60px' }}
              src={logo}
              alt="logo-LottoQuiz"
            />
          </Link>
        </div>
        <div className="right items-center">
          {/*<div className="item-menu">
            <span onClick={() => handlerLinkTo("/")} className="navbar-link">
              <Link to="header" smooth={true} duration={200} spy={true}>Inicio</Link>
            </span>
  </div>*/}
          <div className="item-menu">
            <span className="navbar-link">
              <Link
                to="draw"
                smooth={true}
                duration={200}
                offset={160}
                spy={true}
              >
                Sorteo
              </Link>
            </span>
          </div>
          <div className="item-menu">
            <span className="navbar-link xl:ml-8">
              <Link
                to="result"
                smooth={true}
                duration={200}
                offset={-180}
                spy={true}
              >
                Resultado
              </Link>
            </span>
          </div>
          <div className="item-menu">
            <span className="navbar-link xl:ml-8">
              <Link to="easy" smooth={true} duration={200} spy={true}>
                Fácil de jugar
              </Link>
            </span>
          </div>
          <div className="item-menu">
            <span className="navbar-link xl:ml-8">
              <Link
                to="winner"
                offset={-60}
                smooth={true}
                duration={200}
                spy={true}
              >
                Fácil de ganar
              </Link>
            </span>
          </div>
          {/*<div className="item-menu">
            <span className="navbar-link"><Link to="testimonials" smooth={true} duration={200} spy={true}>Testimonios</Link></span>
          </div>
          <div className="item-menu">
            <span className="navbar-link"><Link to="lottoquiz" smooth={true} duration={200} spy={true}>LottoQuiz</Link></span>
          </div>*/}

          <div className="item-menu">
            <span className="navbar-link xl:ml-8" onClick={handleOpen}>
              Terminos
              <Modal
                isOpen={modal}
                onRequestClose={handleClose}
                style={customStyles}
                contentLabel="Example Modal"
              >
                {/*<button onClick={handleClose}>close</button>*/}
                <div>
                  <Terms />
                </div>
              </Modal>
            </span>
          </div>
          {/* <div className="item-menu">
            <a
              className="btn btn-primary"
              href="https://compras.sellatuserial.com/landing"
            >
              Jugar
            </a>
          </div> */}

          {accessToken && (
            <div className="flex items-center">
              <div className="item-menu">
                <span className="navbar-link xl:ml-8">
                  <button className="button">
                    <Link
                      onClick={() => navigate('/perfil/mis-cartones')}
                      smooth={true}
                      duration={200}
                      spy={true}
                    >
                      Mis Cartones
                    </Link>
                  </button>
                </span>
              </div>

              <div className="item-menu">
                <span className="navbar-link xl:ml-8">
                  <button className="button">
                    <Link
                      onClick={() => navigate('/ventas?tv=true')}
                      smooth={true}
                      duration={200}
                      spy={true}
                    >
                      Sorteo Beisbol en linea
                    </Link>
                  </button>
                </span>
              </div>

              <BtnVentas />
            </div>
          )}
        </div>

        <div className="flex items-center">
          <div className="item-menu hidden lg:block">
            <ButtonGame />
          </div>
        </div>

        {/*button for mobile*/}
        <span className="btn" onClick={() => setShowMenu(!showMenu)}>
          <FaBars />
        </span>
      </div>

      {/*menu for mobile*/}
      <div
        className={`mobile-menu ${
          showMenu ? 'mobile-menu-show' : 'mobile-menu-hide'
        }`}
      >
        {/*<div className="item-menu">
            <span onClick={() => handlerLinkTo("/")} className="mobile-menu-link">
              <Link to="header" smooth={true} duration={200} spy={true}>Inicio</Link>
            </span>
      </div>*/}
        <div className="item-menu">
          <span className="mobile-menu-link">
            <Link
              to="draw"
              smooth={true}
              duration={200}
              offset={160}
              spy={true}
            >
              Sorteo
            </Link>
          </span>
        </div>
        <div className="item-menu">
          <span className="mobile-menu-link">
            <Link
              to="result"
              smooth={true}
              duration={200}
              offset={-180}
              spy={true}
            >
              Resultado
            </Link>
          </span>
        </div>
        <div className="item-menu">
          <span className="mobile-menu-link">
            <Link to="easy" smooth={true} duration={200} spy={true}>
              Fácil de jugar
            </Link>
          </span>
        </div>
        <div className="item-menu">
          <span className="mobile-menu-link">
            <Link
              to="winner"
              offset={-60}
              smooth={true}
              duration={200}
              spy={true}
            >
              Fácil de ganar
            </Link>
          </span>
        </div>
        {/*<div className="item-menu">
            <span className="mobile-menu-link"><Link to="testimonials" smooth={true} duration={200} spy={true}>Testimonios</Link></span>
      </div>
          <div className="item-menu">
            <span className="mobile-menu-link"><Link to="lottoquiz" smooth={true} duration={200} spy={true}>LottoQuiz</Link></span>
          </div>*/}

        <div className="item-menu">
          <span className="mobile-menu-link" onClick={handleOpen}>
            Terminos
            <Modal
              isOpen={modal}
              onRequestClose={handleClose}
              style={customStyles}
              contentLabel="Example Modal"
            >
              {/*<button onClick={handleClose}>close</button>*/}
              <div>
                <Terms />
              </div>
            </Modal>
          </span>
        </div>
        {accessToken && (
          <div>
            <div className="item-menu flex justify-center">
              <button className="play-button">
                <Link
                  onClick={() => navigate('/perfil/mis-cartones')}
                  smooth={true}
                  duration={200}
                  spy={true}
                >
                  Mis Cartones
                </Link>
              </button>
            </div>

            <div className="item-menu">
              <button className="play-button">
                <Link
                  onClick={() => navigate('/ventas?tv=true')}
                  smooth={true}
                  duration={200}
                  spy={true}
                >
                  Sorteo Beisbol en linea
                </Link>
              </button>
            </div>
            <BtnVentasmb />
          </div>
        )}

        <div className="item-menu">
          <ButtonGame />
        </div>
      </div>
    </>
  );
}

export default Navbar;
